import Phaser from 'phaser';
import { getTextStyle } from '../scripts/FontConfig.js';

export default class IntroScene extends Phaser.Scene {
  constructor() {
    super('IntroScene');
  }

  preload() {
    // Load intro carousel images
    // TODO: Replace with actual image paths when available

  }
    createSceneTransitionIn() {
    // Use Phaser's native camera fade in
    this.cameras.main.fadeIn(300, 0, 0, 0);
  }
   createSceneTransitionOut(callback) {
    // Use Phaser's native camera fade out
    this.cameras.main.fadeOut(300, 0, 0, 0);
    this.cameras.main.on('camerafadeoutcomplete', (camera) => {
      callback();
    });
  }

  create() {
    this.createSceneTransitionIn() 
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Background
    // this.add.rectangle(width / 2, height / 2, width, height, 0x2c3e50);
    this.add.image(width / 2, height / 2, 'backgroundScreen').setOrigin(0.5);
    
    // Initialize carousel state
    this.currentSlide = 0;
    this.totalSlides = 5;
    this.isAnimating = false;
    
    // Carousel data with images and captions
    this.carouselData = [
      {
        imageKey: 'intro-1',
        caption: 'Het is woensdagmiddag en je wil buiten spelen met je vrienden.'
      },
      {
        imageKey: 'intro-2', 
        caption: 'Helaas, je vrienden zitten binnen, gehypnoseerd door hun schermpjes.'
      },
      {
        imageKey: 'intro-3',
        caption: 'Zoek je vrienden op en praat met ze om ze te bevrijden.'
      },
      {
        imageKey: 'intro-4',
        caption: 'Zoek de schooltassen bij de voordeur om je vrienden te vinden.'
      },
      {
        imageKey: 'intro-5',
        caption: 'Je kan rondlopen met de pijltjestoetsen of WASD. Veel succes!'
      }
    ];
    
    // Create carousel elements
    this.createCarousel();
    this.createNavigationButtons();
    
    // Show initial slide
    this.showSlide(0);
  }
  
  createCarousel() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Create actual image instead of placeholder rectangle
    this.carouselImage = this.add.image(width / 2, height / 2 - 50, 'intro-1');
    this.carouselImage.setOrigin(0.5);
    
    // Scale image to fit in the 600x300 area if needed
    const maxWidth = 600;
    const maxHeight = 300;
    const scaleX = maxWidth / this.carouselImage.width;
    const scaleY = maxHeight / this.carouselImage.height;
    const scale = Math.min(scaleX, scaleY, 1); // Don't scale up, only down
    this.carouselImage.setScale(scale);
    
    // Image placeholder text (backup, but hidden since we have real images)
    this.imagePlaceholder = this.add.text(width / 2, height / 2 - 50, 'Intro Afbeelding 1', getTextStyle({
      fontSize: '24px',
      fill: '#bdc3c7'
    })).setOrigin(0.5);
    this.imagePlaceholder.setVisible(false); // Hide since we now have real images
    
    // Caption text
    this.captionText = this.add.text(width / 2, height / 2 + 160, '', getTextStyle({
      fontSize: '20px',
      fill: '#ecf0f1',
      align: 'center'
    })).setOrigin(0.5);
    
    // Slide indicator dots
    this.createSlideIndicators();
  }
  
  createSlideIndicators() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    this.slideIndicators = [];
    const indicatorSpacing = 20;
    const startX = width / 2 - ((this.totalSlides - 1) * indicatorSpacing) / 2;
    
    for (let i = 0; i < this.totalSlides; i++) {
      const indicator = this.add.circle(startX + (i * indicatorSpacing), height / 2 + 120, 6, 0x7f8c8d);
      this.slideIndicators.push(indicator);
    }
  }
  
  createNavigationButtons() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;
    
    // Previous button (initially invisible) - proper button style
    this.previousButtonBg = this.add.rectangle(width / 2 - 100, height / 2 + 232, 120, 45, 0x95a5a6);
    this.previousButtonBg.setStrokeStyle(2, 0x7f8c8d);
    this.previousButtonBg.setInteractive({ useHandCursor: true });
    this.previousButtonBg.setVisible(false);
    
    this.previousButtonText = this.add.text(width / 2 - 100, height / 2 + 232, 'Vorige', getTextStyle({
      fontSize: '18px',
      fill: '#ffffff',
      fontWeight: 'bold'
    })).setOrigin(0.5);
    this.previousButtonText.setVisible(false);
    
    // Previous button interactions
    this.previousButtonBg.on('pointerover', () => {
      if (this.previousButtonBg.visible) {
        this.previousButtonBg.setFillStyle(0xbdc3c7);
      }
    });
    this.previousButtonBg.on('pointerout', () => {
      if (this.previousButtonBg.visible) {
        this.previousButtonBg.setFillStyle(0x95a5a6);
      }
    });
    this.previousButtonBg.on('pointerdown', () => {
      if (this.previousButtonBg.visible) {
        this.previousSlide();
      }
    });
    
    // Next button - proper button style
    this.nextButtonBg = this.add.rectangle(width / 2 + 100, height / 2 + 232, 120, 45, 0x3498db);
    this.nextButtonBg.setStrokeStyle(2, 0x2980b9);
    this.nextButtonBg.setInteractive({ useHandCursor: true });
    
    this.nextButtonText = this.add.text(width / 2 + 100, height / 2 + 232, 'Volgende', getTextStyle({
      fontSize: '18px',
      fill: '#ffffff',
      fontWeight: 'bold'
    })).setOrigin(0.5);
    
    // Next button interactions
    this.nextButtonBg.on('pointerover', () => {
      this.nextButtonBg.setFillStyle(0x5dade2);
    });
    this.nextButtonBg.on('pointerout', () => {
      const isLastSlide = this.currentSlide === this.totalSlides - 1;
      this.nextButtonBg.setFillStyle(isLastSlide ? 0x27ae60 : 0x3498db);
    });
    this.nextButtonBg.on('pointerdown', () => {
      this.nextSlide();
    });
  }
  
  showSlide(slideIndex, direction = 'next') {
    const slideData = this.carouselData[slideIndex];
    
    // Prevent multiple animations
    if (this.isAnimating) return;
    this.isAnimating = true;
    
    // Animation duration
    const animDuration = 300;
    
    // Fade out current content
    this.tweens.add({
      targets: [this.carouselImage, this.imagePlaceholder, this.captionText],
      alpha: 0,
      duration: animDuration / 2,
      ease: 'Power2',
      onComplete: () => {
        // Update content while faded out - use actual images now
        const width = this.cameras.main.width;
        const height = this.cameras.main.height;
        
        // Remove old image and placeholder
        if (this.carouselImage) {
          this.carouselImage.destroy();
        }
        if (this.imagePlaceholder) {
          this.imagePlaceholder.destroy();
        }
        
        // Create new image with actual asset
        this.carouselImage = this.add.image(width / 2, height / 2 - 50, slideData.imageKey);
        this.carouselImage.setOrigin(0.5);
        
        // Scale image to fit in the 600x300 area if needed
        const maxWidth = 600;
        const maxHeight = 300;
        const scaleX = maxWidth / this.carouselImage.width;
        const scaleY = maxHeight / this.carouselImage.height;
        const scale = Math.min(scaleX, scaleY, 1); // Don't scale up, only down
        this.carouselImage.setScale(scale);
        
        // Create placeholder text as backup (will be invisible if image loads correctly)
        this.imagePlaceholder = this.add.text(width / 2, height / 2 - 50, `Intro Afbeelding ${slideIndex + 1}`, getTextStyle({
          fontSize: '24px',
          fill: '#bdc3c7'
        })).setOrigin(0.5);
        this.imagePlaceholder.setVisible(false); // Hide since we now have real images
        
        // Update caption
        this.captionText.setText(slideData.caption);
        
        // Slide animation based on direction
        const slideOffset = direction === 'next' ? 50 : -50;
        
        // Set initial position for slide-in effect
        this.carouselImage.x += slideOffset;
        this.imagePlaceholder.x += slideOffset;
        this.captionText.x += slideOffset;
        
        // Fade in and slide to final position
        this.tweens.add({
          targets: [this.carouselImage, this.imagePlaceholder, this.captionText],
          alpha: 1,
          x: `+=${-slideOffset}`,
          duration: animDuration / 2,
          ease: 'Power2',
          onComplete: () => {
            this.isAnimating = false;
          }
        });
      }
    });
    
    // Animate slide indicators
    this.slideIndicators.forEach((indicator, index) => {
      const targetColor = index === slideIndex ? 0x3498db : 0x7f8c8d;
      const targetScale = index === slideIndex ? 1.2 : 1;
      
      this.tweens.add({
        targets: indicator,
        scaleX: targetScale,
        scaleY: targetScale,
        duration: animDuration,
        ease: 'Back.out',
        onStart: () => {
          indicator.setFillStyle(targetColor);
        }
      });
    });
    
    // Update button visibility and text with animation
    this.updateNavigationButtons();
  }
  
  updateNavigationButtons() {
    // Previous button: fade in/out based on slide
    if (this.currentSlide === 0) {
      this.tweens.add({
        targets: [this.previousButtonBg, this.previousButtonText],
        alpha: 0,
        duration: 200,
        ease: 'Power2',
        onComplete: () => {
          this.previousButtonBg.setVisible(false);
          this.previousButtonText.setVisible(false);
        }
      });
    } else {
      this.previousButtonBg.setVisible(true);
      this.previousButtonText.setVisible(true);
      this.tweens.add({
        targets: [this.previousButtonBg, this.previousButtonText],
        alpha: 1,
        duration: 200,
        ease: 'Power2'
      });
    }
    
    // Next button: animate text and color changes
    if (this.currentSlide === this.totalSlides - 1) {
      // Animate to "Start" button
      this.tweens.add({
        targets: [this.nextButtonBg, this.nextButtonText],
        scaleX: 0.9,
        scaleY: 0.9,
        duration: 100,
        ease: 'Power2',
        yoyo: true,
        onComplete: () => {
          // when the scene is triggered as 
          const sceneData = this.scene.settings.data;
          const nextButtonLbl = (sceneData && sceneData.isHelp) ? 'Hoofdmenu' : 'Start';
          this.nextButtonText.setText(nextButtonLbl);
          this.nextButtonBg.setFillStyle(0x27ae60); // Green for start
          this.nextButtonBg.setStrokeStyle(2, 0x229954);
        }
      });
    } else {
      // Animate to "Volgende" button
      this.tweens.add({
        targets: [this.nextButtonBg, this.nextButtonText],
        scaleX: 0.9,
        scaleY: 0.9,
        duration: 100,
        ease: 'Power2',
        yoyo: true,
        onComplete: () => {
          this.nextButtonText.setText('Volgende');
          this.nextButtonBg.setFillStyle(0x3498db); // Blue for next
          this.nextButtonBg.setStrokeStyle(2, 0x2980b9);
        }
      });
    }
  }
  
  previousSlide() {
    if (this.currentSlide > 0 && !this.isAnimating) {
      this.currentSlide--;
      this.showSlide(this.currentSlide, 'previous');
    }
  }
  
  nextSlide() {
    if (this.isAnimating) return;
    
    if (this.currentSlide < this.totalSlides - 1) {
      // Go to next slide
      this.currentSlide++;
      this.showSlide(this.currentSlide, 'next');
    } else {
      // Last slide - start the game
      this.startGame();
    }
  }



  
  startGame() {
    // Get the data passed from StartScene to determine if it's a new game or resume
    const sceneData = this.scene.settings.data;
    
    if (sceneData && sceneData.isHelp) {
      // Return to StartScene when used as help
        this.createSceneTransitionOut(() => {
            this.scene.start('StartScene');
        });
    } else if (sceneData && sceneData.isResume) {
      // Resume existing game
        this.createSceneTransitionOut(() => {
            this.scene.start('VillageScene');
        });
    } else {
      // Start new game - could go to VillageScene or another initial scene
        this.createSceneTransitionOut(() => {
            this.scene.start('VillageScene');
        });
    }
  }
}